export default import.meta.ROLLDOWN_FILE_URL_0XuMPNqYNXuWJL$eu$YoOQ